export const AVAILABLE_FORMATS = {
  video: ['mp4', 'avi', 'mkv', 'mxf', 'ts', 'mov'],
  img: ['jpg', 'jpeg', 'png', 'webp', 'heic', 'heif'],
  // Только PDF: он одинаково открывается и в браузере, и системным просмотрщиком телефона (18243)
  document: ['pdf']
};

/**
 * Форматирует массив форматов в строку описания
 * @param root0 - пропсы
 * @param root0.formats - массив форматов
 * @param root0.isUppercase - делать ли форматы заглавными буквами
 * @param root0.exclude - массив форматов для исключения из описания
 */
const getFormatsDescription = ({
  formats,
  isUppercase = false,
  exclude = []
}: {
  formats: string[];
  isUppercase?: boolean;
  exclude?: string[];
}): string => {
  const filteredFormats = formats.filter(format => !exclude.includes(format));

  if (filteredFormats.length === 0) return '';
  // isUppercase учитываем и для единственного формата, иначе PDF выводился как «.pdf»
  if (filteredFormats.length === 1) {
    const [format] = filteredFormats;

    return `.${isUppercase ? format.toUpperCase() : format}`;
  }

  const formattedFormats = filteredFormats.map(
    format => `.${isUppercase ? format.toUpperCase() : format}`
  );
  const lastFormat = formattedFormats.pop();

  return `${formattedFormats.join(', ')} и ${lastFormat}`;
};

export const AVAILABLE_FORMATS_DESCRIPTION = {
  img: getFormatsDescription({
    formats: AVAILABLE_FORMATS.img,
    exclude: ['jpeg']
  }),
  video: getFormatsDescription({
    formats: AVAILABLE_FORMATS.video,
    isUppercase: true
  }),
  document: getFormatsDescription({
    formats: AVAILABLE_FORMATS.document,
    isUppercase: true
  })
};

export const KiloByte = 1024;
export const MegaByte = 1024 * KiloByte;
